import { defineMessages } from "react-intl";

const baseId = "t.components.twoFactorAuth.";

export default defineMessages({
  otpSentTo: {
    id: baseId + "otpSentTo",
    defaultMessage: "The OTP code has been sent to:",
  },
  uigpOtpTitle: {
    id: baseId + "uigpOtpTitle",
    defaultMessage: "UIGP OTP",
  },
  otpLabel: {
    id: baseId + "otpLabel",
    defaultMessage: "OTP code",
  },
  errorOtp: {
    id: baseId + "errorOtp",
    defaultMessage: "ERROR",
  },
  errorOtpContent: {
    id: baseId + "errorOtpContent",
    defaultMessage: "ERROR OTP MSG",
  },
  mobileResponseError: {
    id: baseId + "mobileResponseError",
    defaultMessage:
      "Please verify that you mobile number has been added and it is verified",
  },
});
